"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unityColorToHex = exports.hexToUnityColor = void 0;
const HEX_REGEX = /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})?/;
const hexToUnityColor = (hexColor) => {
    const result = HEX_REGEX.exec(hexColor);
    if (!result) {
        return { r: 0, g: 0, b: 0, a: 1 };
    }
    const [, r, g, b, a] = result;
    return {
        r: parseInt(r, 16) / 255,
        g: parseInt(g, 16) / 255,
        b: parseInt(b, 16) / 255,
        a: a ? parseInt(a, 16) / 255 : 1,
    };
};
exports.hexToUnityColor = hexToUnityColor;
const unityColorToHex = (unityColor, includeAlpha = true) => {
    const r = Math.round(unityColor.r * 255)
        .toString(16)
        .padStart(2, '0')
        .toUpperCase();
    const g = Math.round(unityColor.g * 255)
        .toString(16)
        .padStart(2, '0')
        .toUpperCase();
    const b = Math.round(unityColor.b * 255)
        .toString(16)
        .padStart(2, '0')
        .toUpperCase();
    const a = Math.round(unityColor.a * 255)
        .toString(16)
        .padStart(2, '0')
        .toUpperCase();
    return `#${r}${g}${b}${includeAlpha && a !== 'FF' ? a : ''}`;
};
exports.unityColorToHex = unityColorToHex;
